import React from "react";
import { createPortal } from "react-dom";
import { useGlobalContext } from "../../scanview/ScanViewerContext";

const MobilePortal = ({
  children,
  elementId,
}: {
  children: React.ReactNode;
  elementId: string;
}) => {
  const { isMobile } = useGlobalContext();
  const element = document.getElementById(elementId);
  if (isMobile && element) {
    return <>{createPortal(children, element)}</>;
  }
  return <>{children}</>;
};

export default MobilePortal;
